import PageHeader from "@/components/PageHeader";
import ProductsTeaser from "@/components/ProductsTeaser";
import CTASection from "@/components/CTASection";
import SEO from "@/components/SEO";

export default function Products() {
  return (
    <>
      <SEO
        title="Enterprise Products | Legacy Testing Suite & AI Usage Analytics"
        description="Two flagship enterprise products: a fully automated testing suite for legacy code modernization, and enterprise AI usage analytics & workflow provenance."
        path="/products"
      />
      <PageHeader
        eyebrow="> /products"
        title="Enterprise-grade products, built by engineers for engineers."
        subtitle="Two flagship products that ship inside the most demanding enterprise environments. Deployable on your own cloud. Auditable. Verifiable."
      />
      <ProductsTeaser />
      <CTASection
        title="Want a walkthrough?"
        subtitle="15 minutes. No sales pitch. See the actual product and architecture."
        ctaLabel="Book a demo"
      />
    </>
  );
}
